var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[(_vm.isShow)?_c('el-header',{staticStyle:{"padding":"0"}},[_c('router-view',{attrs:{"name":"vheader"}})],1):_vm._e(),_c('el-main',{staticStyle:{"overflow":"initial"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }